import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Simple authentication check without complex logic
const ProtectedRoute = ({ children, requiredRole = null, requiredRoles = [] }) => {
  const location = useLocation();
  const { user, loading, isInitialized } = useAuth();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Wait for AuthContext to initialize
    if (!isInitialized) {
      return;
    }

    // Simple check for user authentication
    const checkAuth = () => {
      try {
        // First check if user is set in AuthContext
        if (user) {
          setIsAuthenticated(true);
        } else {
          // Fallback to localStorage check
          const currentUser = localStorage.getItem('currentUser');
          if (currentUser) {
            setIsAuthenticated(true);
          } else {
            setIsAuthenticated(false);
          }
        }
      } catch (error) {
        console.error('Error checking auth:', error);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    // Check immediately
    checkAuth();
  }, [user, isInitialized]);

  // Show loading while AuthContext is initializing or checking auth
  if (!isInitialized || loading || isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // For now, allow all authenticated users (role checks disabled to prevent loops)
  return children;
};

export default ProtectedRoute;